<template>
  <div class="loginall">
    <banner-top :text="titletext"></banner-top>
    <div class="loginFuc">
        <div v-if="checked">{{check?'更换手机':'绑定手机'}}</div>
        <div v-if="!checked">{{check?'更换邮箱':'绑定邮箱'}}</div>
    </div>
    <el-form v-if="checked">
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon2.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="Iphone.phone"
                placeholder='请输入手机号码'
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="Iphone.code"
                placeholder='请输入验证码'
                maxlength="6"
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText1}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
    </el-form>
    <el-form v-if="!checked">
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon5.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="Email.email"
                placeholder='请输入邮箱'
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="Email.code"
                placeholder='请输入验证码'
                maxlength="6"
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText2}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
    </el-form>
    <button @click="toBinding">
        确认绑定
    </button>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'banding',
  components: { bannerTop },
  data () {
    return {
      checked: true,
      check: false,
      titletext: '',
      Iphone: {
        phone: '',
        code: ''
      },
      Email: {
        email: '',
        code: ''
      },
      codeText1: '获取验证码',
      codeText2: '获取验证码',
      myTime1: null,
      myTime2: null
    }
  },
  created () {
    if (this.$route.query.type === 'phone') {
      this.checked = true
    } else {
      this.checked = false
    }
    this.check = this.$route.query.flag
    if (this.$route.query.flag) {
      this.titletext = '更换'
    } else {
      this.titletext = '绑定'
    }
  },
  methods: {
    toBinding () {
      if (this.checked) {
        http['put']('account/phone', this.Iphone).then(() => {
          this.$router.push({name: 'personal'})
        })
      } else {
        http['put']('account/email', this.Email).then(() => {
          this.$router.push({name: 'personal'})
        })
      }
    },
    async onCode () {
      if (this.checked) {
        const data = {
          phone: this.Iphone.phone,
          type: 'update'
        }
        http['post']('auth/request_code/phone', data)
        await this.setTime(60 * 1000)
      } else {
        const data = {
          email: this.Email.email,
          type: 'update'
        }
        http['post']('auth/request_code/email', data)
        await this.setTime(60 * 1000)
      }
    },
    setTime (time) {
      return new Promise((resolve, reject) => {
        if (this.checked) {
          if (this.myTime1) return
          this.codeText1 = time / 1000 + '秒'
          this.myTime1 = setInterval(() => {
            time = time - 1000
            this.codeText1 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime1)
              this.myTime1 = null
              this.codeText1 = '获取验证码'
              resolve()
            }
          }, 1000)
        } else {
          if (this.myTime2) return
          this.codeText2 = time / 1000 + '秒'
          this.myTime2 = setInterval(() => {
            time = time - 1000
            this.codeText2 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime2)
              this.myTime2 = null
              this.codeText2 = '获取验证码'
              resolve()
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginall {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.loginFuc {
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.loginFuc div {
    padding: 1rem 2.4rem;
    font-family: "PingFang-SC-Medium";
    font-size: 18px;
    color: #666;
}
.active {
    color: #ffb949!important;
    border-bottom: 2px solid #ffb949;
}
.loginPassword {
    display: flex;
    justify-content: center;
    width: 70%;
    border-bottom: 1px solid #e6e6e6;
}
.inputpass>>>.el-input__inner {
  border: 0;
}
.iconimg {
    width: 30px;
    height: 30px;
    margin-left: 10px;
}
.loginall button {
    width: 18rem;
    height: 3.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    margin-bottom: 1rem;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/mine/binding.vue